// Associate feature helpers (ported from v1 util/Util.js + AssociatePerformance.getAssociateLink).

/** Auto-refresh interval for the associate views (ms). */
export function getRefreshInterval(): number {
  return 60000;
}

/**
 * Locale-aware date/time format options (ported verbatim from v1 util/Constants.js
 * DATE_TIME_FORMAT). Produces e.g. "October 2, 2025, 14:33:07 GMT+1".
 */
export const DATE_TIME_FORMAT: Intl.DateTimeFormatOptions = {
  year: 'numeric',
  month: 'long',
  day: 'numeric',
  hour: '2-digit',
  minute: '2-digit',
  second: '2-digit',
  timeZoneName: 'short',
  hourCycle: 'h23',
};

/**
 * Current date/time formatted for the given locale (ported from v1 getCurrentFormattedTime).
 * `new Intl.DateTimeFormat(locale, DATE_TIME_FORMAT).format(new Date())`.
 */
export function getCurrentFormattedTime(locale: string): string {
  return new Intl.DateTimeFormat(locale, DATE_TIME_FORMAT).format(new Date());
}

/** Humanize a login id for display (v1 getAliasFromLoginId). */
export function getAliasFromLoginId(loginId: string): string {
  return (loginId ?? '').replace(/@.*$/, '');
}

/** Build the Search-app deep-link for one associate (ported from v1 getAssociateLink). */
export function buildAssociateSearchLink(baseURL: string, loginId: string): string {
  let baseUrl = (baseURL ?? '').toString();
  if (baseUrl.includes('associateinduct')) baseUrl = baseUrl.replace('associateinduct', 'search');
  else baseUrl = baseUrl.replace('induct', 'search');

  let searchURL: URL;
  try {
    searchURL = new URL(baseUrl);
  } catch {
    return '#';
  }

  const startDate = new Date();
  startDate.setHours(0, 0, 0, 0);
  const endDate = new Date();
  endDate.setDate(startDate.getDate() + 1);
  endDate.setHours(0, 0, 0, 0);

  const optionsObj = { type: 'ASSOCIATE', startDate: startDate.getTime(), endDate: endDate.getTime() };
  searchURL.searchParams.set('shareableLink', `/detailPage/${loginId}/${JSON.stringify(optionsObj)}`);
  return searchURL.href;
}

/** HSL color generator for chart series (ported from v1 generateColor). */
export function generateColor(index: number): string {
  const hue = (index * 137.508) % 360;
  const saturation = 70 + (index % 3) * 10;
  const lightness = 45 + (index % 4) * 5;
  return `hsl(${hue}, ${saturation}%, ${lightness}%)`;
}
